import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: 'en_gb',
    fallbackLng: 'en_gb',
    react: {
      wait: true,
      useSuspense: false,
    },
    backend: {
      loadPath: `${rootUrl}/mobile/locales/{{lng}}/{{ns}}.json`,
      parse(data) {
        return JSON.parse(data).data;
      },
    },
  });


export default i18n;
